// Slice H8 — URL-scheme safety filter, split from MarkdownMessage.jsx
// so the node:test suite can exercise it without a JSX transpiler.
//
// Returns the original (or trimmed) URL when the scheme is safe, or
// null when the URL must be stripped. The MarkdownMessage component
// uses null as the signal to render the original anchor children as
// plain text and drop the link entirely.
//
// Acceptance Gate #9: must block javascript: and data: schemes in
// links and images.

const SAFE_SCHEME_RE   = /^(https?:|mailto:|tel:|#|\/|\.\.?\/|\?)/i;
const UNSAFE_SCHEME_RE = /^(javascript|data|vbscript|file):/i;

function safeUrl(href) {
  if (typeof href !== "string") return null;
  const trimmed = href.trim();
  if (!trimmed) return null;
  if (UNSAFE_SCHEME_RE.test(trimmed)) return null;
  // Allow http(s), mailto, tel, fragments, root paths, relative paths,
  // and bare-query URLs.
  if (SAFE_SCHEME_RE.test(trimmed)) return trimmed;
  // No scheme prefix at all → treat as relative path (still safe).
  if (!/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return trimmed;
  // Anything else has an unrecognized scheme → unsafe.
  return null;
}

export { safeUrl, SAFE_SCHEME_RE, UNSAFE_SCHEME_RE };
